import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Text } from 'src/Components'
import { setCurrentClient } from 'src/actions/client'

import styles from './NotFound.module.scss'

const NotFound = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCurrentClient(null))
  }, [dispatch])

  return (
    <div className={styles.container}>
      <img src='/homes/img/not_found.svg' alt='Not found' />
      <Text size='xl' weight='light'>
        <FormattedMessage
          id='Application.notFound.headline'
          defaultMessage='Page not found'
        />
      </Text>
      <Text color='quiet'>
        <FormattedMessage
          id='Application.notFound.bodyText'
          defaultMessage='The page you’re looking for doesn’t exist.'
        />
      </Text>
    </div>
  )
}

export default NotFound
